import React from 'react'
import { IUser } from '@/model/types/user'
import Table, { ColumnsType } from 'antd/lib/table'
import $msg from '@/utils/message'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { showLayer } from '@/utils/layer'
import UpdateDetailInfo from '../stock-update-detail/update-detail-info'
import StockUpdateForm from '../stock-update-form/stock-update-form'

interface InventoryList {
    goods_change_num: number
    goods_num: number
    inventory: {
        create_time: string
        creator: {
            id: number
            user: IUser
        }
        id: number
        shop: number
        status: number
        update_time: string
    }
}

interface StockUpdateTableProps {
    refreshStatus: boolean
    date: string[]
}

const StockUpdateTable: React.FC<StockUpdateTableProps> = props => {
    const columns: ColumnsType<InventoryList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '盘点时间',
            key: 'inventory_time',
            dataIndex: 'inventory',
            render: value => value.update_time,
        },
        {
            title: '盘点商品数',
            key: 'goods_num',
            dataIndex: 'goods_num',
        },
        {
            title: '变动商品数',
            key: 'goods_change_num',
            dataIndex: 'goods_change_num',
        },
        {
            title: '状态',
            key: 'status',
            width: 80,
            dataIndex: 'inventory',
            render: val => <div className={val.status ? '' : 'danger-color'}>{!val.status ? '草稿' : '已盘点'}</div>,
        },
        {
            title: '操作',
            key: 'is_draft',
            width: 70,
            dataIndex: 'inventory',
            align: 'center',
            render: (val, record) => (
                <span
                    className="action"
                    onClick={() => {
                        showLayer(
                            val.status ? (
                                <UpdateDetailInfo inventyId={record.inventory.id} />
                            ) : (
                                <StockUpdateForm refresh={requestHandle.refresh} inventoryId={record.inventory.id} />
                            ),
                        )
                    }}
                >
                    {!val.status ? '编辑' : '详情'}
                </span>
            ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: InventoryList[]
            pagination: IPagination
        },
        {
            inventory_list: InventoryList[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/warehouse/getinventorylist',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    from_date: props.date[0],
                    to_date: props.date[1],
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.inventory_list,
                    pagination: data.pagination,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
            refreshDeps: [props.refreshStatus, props.date],
        },
    )

    return (
        <div className="table-container">
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.inventory.id}
                                loading={requestHandle.loading || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
}

export default StockUpdateTable
